<template>
    <apexchart type="radar" height="600" :options="chart.chartOptions" :series="chart.series"/>
</template>

<script>
    export default {
        props: {
            item: {
                type: Array,
                default: function () {
                    return [1.01, 0.705, 1.01, 1.01, 1.01, 0.605];
                }
            },
            labels: {
                type: Array,
                default: function () {
                    return ['sop', 'ipa', 'ksd', 'iemo', 'kyad', 'ia'];
                }
            }
        },
        computed: {
            chart() {
                return {
                    series: [{
                        name: 'Нормальные показатели',
                        data: [1.01, 0.705, 1.01, 1.01, 1.01, 0.605],
                    }, {
                        name: 'Показатели клиента',
                        data: this.item,
                    }],
                    chartOptions: {
                        chart: {
                            dropShadow: {
                                enabled: true,
                                blur: 1,
                                left: 1,
                                top: 1
                            },
                            toolbar: {
                                show: false,
                            }
                        },
                        colors: ['#28a745', '#dc3545'],
                        stroke: {
                            width: 3
                        },
                        fill: {
                            opacity: 0.0
                        },
                        markers: {
                            size: 4
                        },
                        yaxis: {
                            min: 0,
                            max: 3.0,
                            show: true,
                            tickAmount: 6,
                            labels: {
                                formatter: function (val) {
                                    return Number(val).toFixed(1);
                                }
                            }
                        },
                        labels: this.labels
                    }
                }
            },
        },
    }
</script>